import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const inactiveClientApi = createAsyncThunk(
  "inactiveClient",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};
    if (name) {
      params.name = name;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/inactiveClient", {
      params, 
    });
    if (response) {
      return response.data;
    }
  }
);

const inactiveClientSlice = createSlice({
  name: "inactiveClient",
  initialState: {
    inactiveClient: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inactiveClientApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(inactiveClientApi.fulfilled, (state, action) => {
        state.inactiveClient = action.payload;
        state.loading = false;
      })
      .addCase(inactiveClientApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default inactiveClientSlice.reducer;

